import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { TextInput } from "@/components/inputs";

/**
 * ReferrerSection — collects optional referrer details (first name, last name, email).
 * All three fields become required if any one of them is filled (co-dependent validation).
 */
export default function ReferrerSection() {
  const { control, formState: { errors } } = useFormContext();
  const e = errors?.referrer;

  return (
    <div>
      <h3 className="mb-1 text-base font-semibold text-gray-900 dark:text-white">Referrer</h3>
      <p className="mb-4 text-sm text-gray-500 dark:text-slate-400">
        The borrower&apos;s referrer (if any)
      </p>
      <div className="grid grid-cols-4 gap-x-4 gap-y-5">
        <div className="col-span-4 sm:col-span-2">
          <Controller name="referrer.firstName" control={control} render={({ field }) => (
            <TextInput placeholder="First Name" value={field.value} onChange={field.onChange} error={e?.firstName?.message} />
          )} />
        </div>
        <div className="col-span-4 sm:col-span-2">
          <Controller name="referrer.lastName" control={control} render={({ field }) => (
            <TextInput placeholder="Last Name" value={field.value} onChange={field.onChange} error={e?.lastName?.message} />
          )} />
        </div>
        <div className="col-span-4 sm:col-span-2">
          <Controller name="referrer.email" control={control} render={({ field }) => (
            <TextInput placeholder="Email" value={field.value} onChange={field.onChange} error={e?.email?.message} />
          )} />
        </div>
      </div>
    </div>
  );
}

